module.exports = __webpack_public_path__ + "img/screenshot1.c388b5e2.png";